import { FLAME_TICKS } from '../core/constants';
import { Cell } from './grid';
import { FlameKind, key } from './bombs';
/**
 * Поширення полум'я хрестом до `range` клітинок у 4 напрямках.
 * HardBlock одразу зупиняє промінь і не горить.
 * SoftBlock зупиняє промінь, горить, руйнується (→ Floor) і тригерить колбек.
 * Зустрівши іншу бомбу, поточний промінь зупиняється, а та детонує ланцюгом.
 */
export function detonate(bomb, grid, bombs, flames, seen = new Set(), hooks = {}) {
    if (bomb.exploded)
        return;
    bomb.exploded = true;
    const addFlame = (c, r, kind) => {
        const k = key(c, r);
        if (seen.has(k))
            return;
        seen.add(k);
        flames.push({ col: c, row: r, life: FLAME_TICKS, maxLife: FLAME_TICKS, kind });
    };
    addFlame(bomb.col, bomb.row, FlameKind.Center);
    const dirs = [
        { dx: 1, dy: 0, mid: FlameKind.Horizontal, end: FlameKind.EndRight },
        { dx: -1, dy: 0, mid: FlameKind.Horizontal, end: FlameKind.EndLeft },
        { dx: 0, dy: 1, mid: FlameKind.Vertical, end: FlameKind.EndDown },
        { dx: 0, dy: -1, mid: FlameKind.Vertical, end: FlameKind.EndUp },
    ];
    for (const d of dirs) {
        for (let i = 1; i <= bomb.range; i++) {
            const c = bomb.col + d.dx * i;
            const r = bomb.row + d.dy * i;
            const t = grid.get(c, r);
            if (t === Cell.HardBlock)
                break;
            if (t === Cell.SoftBlock) {
                grid.set(c, r, Cell.Floor);
                addFlame(c, r, d.end);
                hooks.onSoftDestroyed?.(c, r);
                break;
            }
            const other = bombs.find(b => !b.exploded && b.col === c && b.row === r);
            const isLast = i === bomb.range;
            addFlame(c, r, isLast ? d.end : d.mid);
            if (other) {
                detonate(other, grid, bombs, flames, seen, hooks);
                break;
            }
        }
    }
}
